import React from "react";
import PersonalDataStepShared from "../common/components/PersonalDataStep/PersonalDataStepShared";

/**
 * Venue reservation customer-data step. Thin wrapper over the shared,
 * prop-gated {@link PersonalDataStepShared} (issue #868): same as the room flow
 * but without the "booking for someone else" radio group.
 *
 * `showAccountLogin` is on here and nowhere else (#1926): venue is where an
 * account changes the booking outcome — an approved organization member books
 * directly and covered — so it is where the offer earns its place.
 *
 * The covered-booking narrowing used to live here as a local
 * `COVERED_REQUIRED_FIELDS` set passed through `requiredFields`. It has moved
 * into `util/requiredPersonalDataFields.ts`, which the shared step and the
 * Redux gate now both read — because passing it here only removed the
 * asterisks: `isPersonalDataValid` kept demanding a billing address, so a
 * covered booking could not actually be completed.
 */
const PersonalDataStep = () => (
  <PersonalDataStepShared showCompany showAddress showAccountLogin />
);

export default PersonalDataStep;
